import { Country, EnumSchema, FromSchema, OptionalString } from '@40seas/entities/common';
import { addressProvider } from '@40seas/shared/address';
import { z } from 'zod';

export const AddressSchema = z
    .object({
        country: EnumSchema(Country).refine((country) => country, {
            message: 'Country is required',
            path: ['country'],
        }),
        state: OptionalString(z.string().min(1)),
        city: OptionalString(z.string().min(1)),
        addressLine1: OptionalString(z.string().min(1)),
        addressLine2: OptionalString(z.string().min(1)),
        zipCode: OptionalString(z.string()),
    })
    .strict()
    .refine((address) => (address.zipCode ? addressProvider.isValidZipCode(address.country, address.zipCode) : true), {
        message: 'zipCode is not valid',
        path: ['zipCode'],
    });

export class Address extends FromSchema(AddressSchema) {
    country?: Country;
    state?: string;
    city?: string;
    addressLine1?: string;
    addressLine2?: string;
    zipCode?: string;
}
